import CryptoJS from 'crypto-js' //引用AES源码js

const key = CryptoJS.enc.Utf8.parse("ihaierForTodoKey"); //十六位十六进制数作为密钥
const iv = CryptoJS.enc.Utf8.parse('ihaierForTodo_Iv'); //十六位十六进制数作为密钥偏移量

//解密方法
function Decrypt(word) {
  let encryptedHexStr = CryptoJS.enc.Hex.parse(word);
  let srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
  let decrypt = CryptoJS.AES.decrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
  return decryptedStr.toString();
}

//加密方法
function Encrypt(word) {
  var _word = CryptoJS.enc.Utf8.parse(word),
    _key = CryptoJS.enc.Utf8.parse("ihaierForTodoKey"),
    _iv = CryptoJS.enc.Utf8.parse("ihaierForTodo_Iv");
  var encrypted = CryptoJS.AES.encrypt(_word, _key, {
    iv: _iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.toString();

  // let srcs = CryptoJS.enc.Utf8.parse(word);
  // let encrypted = CryptoJS.AES.encrypt(srcs, key, {
  //   iv: iv,
  //   mode: CryptoJS.mode.CBC,
  //   padding: CryptoJS.pad.Pkcs7
  // });
  // return encrypted.ciphertext.toString().toUpperCase();
}

export default {
  Decrypt,
  Encrypt
}



//////////////////
// WEBPACK FOOTER
// ./static/js/AESUtil.js
// module id = null
// module chunks = 